import React, { Component } from "react";

export default class LimiteInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            LimiteCompraMaximo: props.data.LimiteCompraMaximo,
            mensaje: null
        }

        this.changeInput = this.changeInput.bind(this);
    }

    changeInput(event) {
        this.props.changeInput("LimiteCompraMaximo", event.target.value)
    }

    validarCampo(event) {
        let valor = event.target.value;
        let limiteMinimo
        let moneda = "$"
        if(this.props.data.GET_PARAMETRO_GENERAL.MONEDALIMITECOMPRA != "D"){
            limiteMinimo = this.props.cuentaTipo.LimiteMinimoCompraPeso;
        }else{
            limiteMinimo = this.props.cuentaTipo.LimiteMinimoCompraDolar;
            moneda = "u$s"
        }
        
        if (/^[0-9]*$/g.test(valor) || valor.replace(/\s/g, "", "") == "") {
            const objState = { mensaje: null, LimiteCompraMaximo: valor };

            if (valor < limiteMinimo) {
                objState.mensaje = `El límite de compra mínimo es de ${moneda} ${limiteMinimo}`;
            }

            this.setState(objState);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            LimiteCompraMaximo: nextProps.data.LimiteCompraMaximo
        });
    }

    render() {
        const { data } = this.props;
        let moneda = "$"
        if(data.GET_PARAMETRO_GENERAL.MONEDALIMITECOMPRA=="D") moneda = "u$s"

        return (
            <div className="row top-separator-xs">
                <div className="row">
                    <div className="col-xs-3">
                        <label className="lbl-radio label-secondary">Límite de Compra Máximo {moneda}</label>
                    </div>
                    <div className="col-xs-2">
                        <input
                            className="form-control default-input"
                            onBlur={(e) => this.changeInput(e)}
                            onChange={(e) => this.validarCampo(e)}
                            value={this.state.LimiteCompraMaximo}
                            type="text"
                            pattern="[0-9]*"
                            maxLength={11}
                        />
                    </div>
                </div>
                    <div className="col-md-12">
                    {(data.ERROR_PRODUCT["seleccionoLimiteInput"] == false && this.state.mensaje != null) && <div className="col-xs-4">
                        <label className="error">{this.state.mensaje}</label>
                    </div>}
                    {(data.ERROR_PRODUCT["seleccionoLimiteInput"] == false && this.state.mensaje == null) &&
                        <label className="error">{"Ingrese el monto máximo del límite de compra"}</label>}
                    </div>
            </div>
        );
    }
}